import { isProd } from 'helpers/helper_functions';

const _ = require('underscore');

const ADMIN_FILTERS = [
  {
    attribute: 'sales_rep',
    display: 'Sales Rep',
    placeholder: 'Sales Rep',
    type: 'sales_rep',
    color: 'success',
    localizationSlug: 'SALES_REP',
    placeholderLocalizationSlug: 'SALES_REP',
  },
  {
    attribute: 'account_manager',
    display: 'Account Manager',
    placeholder: 'Account Manager',
    type: 'account_manager',
    color: 'success',
    localizationSlug: 'ACCOUNT_MANAGER',
    placeholderLocalizationSlug: 'ACCOUNT_MANAGER',
  },
  {
    attribute: 'reference',
    display: 'Reference #',
    placeholder: 'Enter a reference number (Ex: 123456)',
    type: 'text',
    color: 'success',
    localizationSlug: 'REFERENCE_HASH',
    placeholderLocalizationSlug: 'ENTER_A_REFERENCE_NUMBER',
  },
  {
    attribute: 'origin',
    display: 'Origin Name',
    type: 'text',
    color: 'warning',
    localizationSlug: 'ORIGIN_NAME',
  },
  {
    attribute: 'near_origin',
    display: 'Origin Address',
    type: 'location_address',
    color: 'warning',
    localizationSlug: 'ORIGIN_ADDRESS',
  },
  {
    attribute: 'destination',
    display: 'Destination Name',
    type: 'text',
    color: 'warning',
    localizationSlug: 'DESTINATION_NAME',
  },
  {
    attribute: 'near_destination',
    display: 'Destination Address',
    type: 'location_address',
    color: 'warning',
    localizationSlug: 'DESTINATION_ADDRESS',
  },
  {
    attribute: 'status',
    display: 'Status',
    type: 'status',
    color: 'warning',
    localizationSlug: 'STATUS',
  },
  {
    attribute: 'carrier',
    display: 'Carrier',
    type: 'carrier',
    customerType: 'carriers',
    color: 'info',
    localizationSlug: 'CARRIER',
  },
  {
    attribute: 'master_shipper',
    display: 'Master Account',
    type: 'master_shipper',
    customerType: 'master_shippers',
    color: 'info',
    localizationSlug: 'MASTER_ACCOUNT',
  },
  {
    attribute: 'shipper',
    display: 'Shipper',
    type: 'shipper',
    customerType: 'shippers',
    color: 'info',
    localizationSlug: 'SHIPPER',
  },
  {
    attribute: 'driver',
    display: 'Driver',
    type: 'driver',
    customerType: 'drivers',
    color: 'info',
    localizationSlug: 'DRIVER',
  },
  {
    attribute: 'daterange',
    display: 'Date Range',
    type: 'daterange',
    color: 'warning',
    localizationSlug: 'DATE_RANGE',
  },
  {
    attribute: 'tags',
    display: 'Tags',
    type: 'text',
    placeholder: 'Enter a tag name (Ex. longhaul)',
    color: 'success',
    localizationSlug: 'TAGS',
    placeholderLocalizationSlug: 'ENTER_A_TAG_NAME',
  },
  {
    attribute: 'shipment_type',
    display: 'Shipment Type',
    type: 'shipment_types',
    color: 'info',
    localizationSlug: 'SHIPMENT_TYPE',
  },
  {
    attribute: 'market',
    display: 'Market',
    type: 'market',
    color: 'info',
    localizationSlug: 'MARKET',
    count: 1,
  },
  {
    attribute: 'equipment',
    display: 'Equipment',
    type: 'equipment',
    color: 'info',
    localizationSlug: 'EQUIPMENT',
  },
  {
    attribute: 'awaiting_empty_delivery',
    display: 'Awaiting Empty Delivery',
    type: 'awaiting_empty_delivery',
    color: 'info',
    localizationSlug: 'AWAITING_EMPTY_DELIVERY',
  },
  {
    attribute: 'carrier_integrations',
    display: 'Carrier Integrations',
    type: 'carrier_integrations',
    color: 'info',
    localizationSlug: 'CARRIER_INTEGRATIONS',
  },
];

const CARRIER_FILTERS = [
  {
    attribute: 'reference',
    display: 'Reference #',
    placeholder: 'Enter a reference number (Ex: 123456)',
    type: 'text',
    color: 'success',
    localizationSlug: 'REFERENCE_HASH',
    placeholderLocalizationSlug: 'ENTER_A_REFERENCE_NUMBER',
  },
  {
    attribute: 'status',
    display: 'Status',
    type: 'status',
    color: 'warning',
    localizationSlug: 'STATUS',
  },
  {
    attribute: 'daterange',
    display: 'Date Range',
    type: 'daterange',
    color: 'warning',
    localizationSlug: 'DATE_RANGE',
  },
  {
    attribute: 'driver',
    display: 'Driver',
    type: 'driver',
    customerType: 'drivers',
    color: 'info',
    localizationSlug: 'DRIVER',
  },
  {
    attribute: 'carrier_name',
    display: 'Carrier',
    placeholder: 'Enter a carrier name',
    type: 'carrier_associated',
    color: 'success',
    localizationSlug: 'CARRIER',
    placeholderLocalizationSlug: 'ENTER_CARRIER_NAME',
  },
  {
    attribute: 'equipment',
    display: 'Equipment',
    type: 'equipment',
    color: 'info',
    localizationSlug: 'EQUIPMENT',
  },
  {
    attribute: 'awaiting_empty_delivery',
    display: 'Awaiting Empty Delivery',
    type: 'awaiting_empty_delivery',
    color: 'info',
    localizationSlug: 'AWAITING_EMPTY_DELIVERY',
  },
  {
    attribute: 'missing_docs',
    display: 'Missing Documentation',
    type: 'missing_docs',
    color: 'info',
    localizationSlug: 'MISSING_DOCUMENTATION',
  },
];

const CARRIER_SELECT_FILTER = [
  {
    attribute: 'equipment',
    display: 'Equipment',
    type: 'equipment',
    color: 'info',
    localizationSlug: 'EQUIPMENT',
  },
  {
    attribute: 'awaiting_empty_delivery',
    display: 'Awaiting Empty Delivery',
    type: 'awaiting_empty_delivery',
    color: 'info',
    localizationSlug: 'AWAITING_EMPTY_DELIVERY',
  },
  {
    attribute: 'missing_docs',
    display: 'Missing Documentation',
    type: 'missing_docs',
    color: 'info',
    localizationSlug: 'MISSING_DOCUMENTATION',
  },
];

const SHIPPER_FILTERS = [
  {
    attribute: 'shipment_id',
    display: 'Shipment ID',
    placeholder: 'Enter a Shipment ID (Ex: CAR-1001)',
    type: 'text',
    color: 'success',
    localizationSlug: 'SHIPMENT_ID',
    placeholderLocalizationSlug: 'ENTER_A_SHIPMENT_ID',
  },
  {
    attribute: 'reference',
    display: 'Reference #',
    placeholder: 'Enter a reference number (Ex: 123456)',
    type: 'text',
    color: 'success',
    localizationSlug: 'REFERENCE_HASH',
    placeholderLocalizationSlug: 'ENTER_A_REFERENCE_NUMBER',
  },
  {
    attribute: 'daterange',
    display: 'Date Range',
    type: 'daterange',
    color: 'warning',
    localizationSlug: 'DATE_RANGE',
  },
  {
    attribute: 'equipment',
    display: 'Equipment',
    type: 'equipment',
    color: 'info',
    localizationSlug: 'EQUIPMENT',
  },
  {
    attribute: 'awaiting_empty_delivery',
    display: 'Awaiting Empty Delivery',
    type: 'awaiting_empty_delivery',
    color: 'info',
    localizationSlug: 'AWAITING_EMPTY_DELIVERY',
  },
  {
    attribute: 'status',
    display: 'Status',
    type: 'status',
    color: 'warning',
    localizationSlug: 'STATUS',
  },
];

export default {
  SHIPPER_FILTERS: _.sortBy(SHIPPER_FILTERS, 'display'),
  CARRIER_FILTERS,
  CARRIER_SELECT_FILTER,
  ADMIN_FILTERS: _.sortBy(ADMIN_FILTERS, 'display'),
};
